@defer (on idle) {
<app-modern-nav></app-modern-nav>
<app-modern-header></app-modern-header>
<app-modern-about></app-modern-about>
<app-modern-function></app-modern-function>
<app-modern-our-resource></app-modern-our-resource>
<app-modern-team-member></app-modern-team-member>
<app-modern-services></app-modern-services>
<app-mordern-client-capture></app-mordern-client-capture>
<app-modern-footer></app-modern-footer>
} @placeholder {
<div>loading..</div>
}